// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__10Qu7","item":"PaymentsMobile_item__2-dyW","label":"PaymentsMobile_label__3YV55","amount":"PaymentsMobile_amount__1vZmx"};